import React, { Component } from "react";
import { ElementsConsumer, PaymentElement } from "@stripe/react-stripe-js";
import { Spinner } from "react-bootstrap";
import ReservationService from "../../services/ReservationService";

class TripAddonsPaymentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      failedmessage: "",
      hasSubmitted: false,
    };
    this.removeMessage = this.removeMessage.bind(this);
    this.setPrevious = this.setPrevious.bind(this);
  }

  tripAddonsPayment = async (event) => {
    event.preventDefault();
    if (this.state.loader || this.state.hasSubmitted) {
      return;
    }
    this.setState({ loader: true, failedmessage: "" });

    const stripe = this.props.stripe;
    const elements = this.props.elements;

    if (!stripe || !elements) {
      this.setState({
        loader: false,
        failedmessage: "Payment is still loading. Please try again.",
      });
      return;
    }

    try {
      const result = await stripe.confirmPayment({
        elements,
        redirect: "if_required",
      });

      if (result?.error) {
        this.setState({
          loader: false,
          failedmessage: result.error.message || "Payment failed. Please try again.",
        });
        return;
      }

      if (result?.paymentIntent?.status !== "succeeded") {
        this.setState({ loader: false, failedmessage: "Payment failed. Please try again." });
        return;
      }

      const saveData = {
        confirmation_code:      this.props.confirmation_code,
        stripe_transaction_id:  result.paymentIntent.id,
        items:                  this.props.items,
        vehicle_details:        this.props.vehicleDetails || [],
      };

      await ReservationService.storeTripAddonsPayment(saveData);
      this.setState({ hasSubmitted: true });

      if (this.props.onPaymentSuccess) {
        this.props.onPaymentSuccess();
      }
    } catch (error) {
      this.setState({
        loader: false,
        failedmessage: "Something went wrong while processing payment.",
      });
    } finally {
      this.setState({ loader: false });
    }
  };

  removeMessage = () => {
    this.setState({ failedmessage: "" });
  };

  setPrevious = () => {
    if (this.props.onPrevious) {
      this.props.onPrevious();
    }
  };

  render() {
    const { calculatedAmounts } = this.props;
    return (
      <>
        <div>
          <span>
            <h5 className="text-danger decline">{this.state.failedmessage}</h5>
          </span>
        </div>

        {calculatedAmounts && calculatedAmounts.length > 0 && (
          <ul className="parking_pay_detail mg-b-20">
            {calculatedAmounts.map((item, idx) => (
              <li key={idx}>
                <span>
                  {item.type === "pet_cleaning"
                    ? `Pet cleaning fee (${item.quantity} pet${item.quantity > 1 ? "s" : ""})`
                    : `Parking fee (${item.quantity} vehicle${item.quantity > 1 ? "s" : ""})`}
                </span>
                <span>${parseFloat(item.amount).toFixed(2)}</span>
              </li>
            ))}
          </ul>
        )}

        <div>
          <PaymentElement onChange={this.removeMessage} />
          <div className="step_btns">
            <button
              type="button"
              className="w-100 btn_pre_wzd"
              disabled={this.state.loader}
              onClick={this.setPrevious}
            >
              Previous
            </button>
            <button
              type="button"
              className="btn_next_wzd"
              disabled={this.state.loader || this.state.hasSubmitted}
              onClick={(e) => this.tripAddonsPayment(e)}
            >
              {(this.state.loader || this.state.hasSubmitted) ? (
                <>
                  Processing...{" "}
                  <Spinner
                    as="span"
                    animation="grow"
                    role="status"
                    aria-hidden="true"
                    size="sm"
                  />
                </>
              ) : (
                "Pay"
              )}
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default function InjectedTripAddonsPaymentForm(props) {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <TripAddonsPaymentForm
          stripe={stripe}
          elements={elements}
          stripeId={props.stripeId}
          confirmation_code={props.confirmation_code}
          items={props.items}
          calculatedAmounts={props.calculatedAmounts}
          vehicleDetails={props.vehicleDetails}
          onPaymentSuccess={props.onPaymentSuccess}
          onPrevious={props.onPrevious}
        />
      )}
    </ElementsConsumer>
  );
}
